import React,{ useEffect, useState,useRef} from 'react'
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { LoginUser,RegisterUser} from "../../Redux/actions/authentication";

import { Form, Input, Button, Checkbox, Spin, message } from 'antd';
import {
    LoadingOutlined,
    UserOutlined,
} from '@ant-design/icons';
import './styles.scss'

export default function Login() {

    const dispatch = useDispatch()

    const { user } = useSelector(state => ({
  
        user: state.auth.user,

    }), shallowEqual)
    const [loading, setLoading] = useState(false)
    //add w/e for login here
    useEffect(() => {
        // if(!session) return Router.push('/login')
        // if(session) return Router.push('/dashboard')
    }, [])

    const handleSubmit = (values) => {
        console.log(values)
        if(values.password !== values.password2){
            message.warning('passwords do not match')
        }else{
            dispatch(RegisterUser(values))
        }  
    }

    const formRender = () => {
        // if(loading) return <div className='login-container'><Spin size={'large'} tip='Loading...'/></div>
        return(
            <div className='login-container'>
                <Form
                    onFinish={handleSubmit}
                    className="login-form main-form">
                    <Form.Item name="name" className="form-item"
                        rules={[
                            { required: true, message: 'Please input your name!' }]}
                        prefix={<UserOutlined/>} >
                        <Input placeholder="Name" disabled={loading}/>
                    </Form.Item>                        
                    <Form.Item name="email" className="form-item"
                        rules={[
                            { required: true, message: 'Please input your email!' }]}
                        prefix={<UserOutlined/>} >
                        <Input placeholder="Email" disabled={loading} autoComplete='email'/>
                    </Form.Item>
                    <Form.Item name="phoneNumber" className="form-item"
                        rules={[
                            { required: true, message: 'Please input your contact number!' }]}
                        prefix={<UserOutlined/>} >
                        <Input placeholder="Contact Number" disabled={loading}/>
                    </Form.Item>

                    <Form.Item name="password" className="form-item"
                        rules={[{ required: true, message: 'Please input your password!' }]}>
                        <Input  type="password" placeholder="Password" disabled={loading} autoComplete='current-password'/>
                    </Form.Item>
                    <Form.Item name="password2" className="form-item"
                        rules={[{ required: true, message: 'Please input your password!' }]}>
                        <Input  type="password" placeholder="Repeat Password" disabled={loading} autoComplete='current-password'/>
                    </Form.Item>
                  

                    <Form.Item className="form-item">
                        {loading ? <Spin size={'large'} tip='Loading...'/> 
                        : 
                        <Button type="primary" htmlType="submit" className="login-button">
                            Register
                        </Button>}
                    </Form.Item>
                    {loading ? null 
                        : 
                        <Button type="link"  className="login-button" onClick={()=>{window.location.href = '/'}}>
                            Return To Login
                        </Button>}
                </Form>
            </div>
        )
    }

    return(
        formRender()
    )
}